import { gql, useQuery } from "@apollo/client";
import { useState } from "react";
import { Collapse, Row } from "react-bootstrap";
import BlogCategoryButton from "./BlogCategoryButton";

import styles from "./BlogCategoryNav.module.css";
import BlogCategoryToggle from "./BlogCategoryToggle";

const GET_BLOG_CATEGORIES = gql`
  query BlogCategoriesNavigation {
    allBlogCategories {
      __typename
      id
      categoryTitle
      slug
    }
  }
`;

function BlogCategoryNav() {
  const { data } = useQuery(GET_BLOG_CATEGORIES);
  const [open, setOpen] = useState(false);

  const toggleDropdown = () => setOpen(!open);

  const categories = data?.allBlogCategories || [
    { id: 1, slug: "concert-reviews", categoryTitle: "Concert Reviews" },
    { id: 2, slug: "features", categoryTitle: "Features" },
    { id: 3, slug: "dj-picks", categoryTitle: "DJ Picks" },
    { id: 4, slug: "sports", categoryTitle: "Sports" },
    { id: 5, slug: "local-live", categoryTitle: "Local Live" },
  ];

  return (
    <div className={styles.container}>
      <hr className="my-0" />
      <BlogCategoryToggle onClick={toggleDropdown} className={styles.toggle} />
      <Collapse in={open}>
        <Row className={`${styles["category-list"]} px-lg-5`}>
          {categories.map((category) => (
            <BlogCategoryButton
              key={category.id}
              onClick={toggleDropdown}
              {...category}
            />
          ))}
          <BlogCategoryButton onClick={toggleDropdown} review />
        </Row>
      </Collapse>
    </div>
  );
}

export default BlogCategoryNav;
